import { createApp } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowDown,
  faArrowUp,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faClipboardCheck,
  faCog,
  faCogs,
  faDesktop,
  faDownload,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFileDownload,
  faFilePdf,
  faFileUpload,
  faFlag,
  faGlobe,
  faInfoCircle,
  faHourglassStart,
  faHourglassHalf,
  faMagnet,
  faPencilAlt,
  faPhone,
  faSearch,
  faTemperatureLow,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUpload,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import Global from './global';
import App from '../App.vue';
import Modal from '../components/Modal.vue';
import SimpleModal from '../components/SimpleModal.vue';

// Setup App
const setup = (globalConfig) => {
  // App Instance
  const app = createApp(App);

  // Global Singleton
  const global = new Global(globalConfig);

  // Plugins
  app.use(global.router);
  app.use(global.store);

  // Components
  library.add(
    faArrowDown,
    faArrowUp,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faClipboardCheck,
    faCog,
    faCogs,
    faDesktop,
    faDownload,
    faEnvelope,
    faExclamationTriangle,
    faEye,
    faFileDownload,
    faFilePdf,
    faFileUpload,
    faFlag,
    faGlobe,
    faInfoCircle,
    faHourglassStart,
    faHourglassHalf,
    faMagnet,
    faPencilAlt,
    faPhone,
    faSearch,
    faTemperatureLow,
    faThumbsUp,
    faTimes,
    faTimesCircle,
    faTrashAlt,
    faUpload,
    faUser,
  );
  app.component('FontAwesomeIcon', FontAwesomeIcon);
  app.component('FontAwesomeLayers', FontAwesomeLayers);
  app.component('Modal', Modal);
  app.component('SimpleModal', SimpleModal);

  // Global Properties
  app.config.globalProperties.$api = global.api;
  app.config.globalProperties.$apollo = global.apollo;
  app.config.globalProperties.$iam = global.iam;
  app.config.globalProperties.$product = global.product;
  app.config.globalProperties.$support = global.support;
  app.config.globalProperties.$filters = {
    formatDate(value) {
      // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorLanguage/language
      const lang = navigator.language;
      if (value) {
        const date = new Date(value); // value has format 2020-12-31T08:30:59.000Z
        return `${date.toLocaleDateString(lang)} ${date.toLocaleTimeString(lang)}`;
      }
      return '-';
    },
    nbFormat(value) {
      if (value == null || value === '') {
        return '';
      }
      return Number(Number(value).toFixed(3)).toLocaleString('en-US');
    },
  };

  return app;
};

export default {
  setup,
};
